import React, { useCallback } from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";
import { useGA4CommonParameters, useSendImpressionEvents } from "scmp-sdk/components/rosetta/hooks";
import { SubscriptionButton } from "scmp-sdk/components/rosetta/subscription-button/styles";
import type { GA4Event } from "scmp-sdk/lib/google-analytics/ga4-types";

type Props = {
  className?: string;
};
export const RenewButton: React.FunctionComponent<Props> = ({ className }) => {
  const { handleTrackGA4, rosettaInstance } = useSdkContext();
  const { computeGA4CommonParameters } = useGA4CommonParameters();

  const { captureTrackImpressionEventTargetElement, intersection } = useSendImpressionEvents({
    ga4Event: useCallback<() => GA4Event>(
      () => ({
        action: "imp",
        category: "subs",
        customized_parameters: {
          ...computeGA4CommonParameters(),
          call_to_action: "renew",
          trigger_point: "masthead renewal button",
        },
        subcategory: "entry_point",
      }),
      [computeGA4CommonParameters],
    ),
  });
  return (
    <SubscriptionButton
      className={className}
      onClick={() => {
        handleTrackGA4({
          action: "click",
          category: "subs",
          customized_parameters: {
            ...computeGA4CommonParameters(),
            call_to_action: "renew",
            trigger_point: "masthead renewal button",
          },
          subcategory: "entry_point",
        });
        const expiryReminder = rosettaInstance?.rulesEngine.getOutcome("user")?.expiryReminder;
        const { bottom, left, right, top } = intersection?.boundingClientRect ?? {};
        window.postMessage(
          { bottom, expiryReminder, left, right, top, type: "PIANO_RENEW_POPUP" },
          "*",
        );
      }}
      ref={captureTrackImpressionEventTargetElement}
    >
      Renew & Save
    </SubscriptionButton>
  );
};

RenewButton.displayName = "RenewButton";
